/**
 * Calculate row count from query data and pagination
 * 
 * @param {Object} queryData - Query response data
 * @param {Array} data - Current data array
 * @param {Object} pagination - Pagination state
 * @returns {number} Total row count
 */
export const calculateRowCount = (queryData, data, pagination) => {
  if (queryData?.count !== undefined) {
    return queryData.count;
  }
  
  if (queryData?.page && queryData?.page_size) {
    const currentPage = queryData.page;
    const pageSize = queryData.page_size;
    const hasNext = queryData?.has_next || false;
    return hasNext 
      ? (currentPage * pageSize) + data.length 
      : (currentPage - 1) * pageSize + data.length;
  }
  
  return data.length;
};

